import { Routes, Route } from 'react-router-dom';
import MargemBrutaPercentual from '../pages/MargemBruta/margemBrutaPercentual';
import MargemBruta from '../pages/MargemBruta/margemBruta';
import SalariosPorProjeto from '../pages/MargemBruta/salariosPorProjeto';
import CustosPorProjeto from '../pages/MargemBruta/lancamentos';
import SimuladorFolha from '../pages/MargemBruta/simulacaoFolha';
import OrcamentoDash from '../pages/Orcamento/orcamentoDash'
import Login from '../pages/Auth/login';
import Register from '../pages/Auth/registro';
import EsqueciSenha from '../pages/Auth/esqueciSenha';
import RedefinirSenha from '../pages/Auth/redefinirSenha';
import Inicio from '../pages/Home/inicio'
import PainelExecutivo from '../pages/Dash/painelExecutivo'
import Pagamentos from '../pages/Dash/pagamentos'
import Recebimentos from '../pages/Dash/recebimento'
import PrivateRoute from '../PrivateRoute';
import GoogleFormFinanceiro from '../pages/GestaoFinanceiraProjetos/formularioGp';
import MinhasSolicitacoes from '../pages/GestaoFinanceiraProjetos/minhasSolicitacoes';
import FaturamentoGp from '../pages/GestaoFinanceiraProjetos/faturamentoGp';
import TabelaLuciano from '../pages/MargemBruta/dadosLuciano'
import Inadimplencia from '../pages/PainelExecutivo/inadimplencia';
import ControleCompetencia from '../pages/PainelExecutivo/competencia';
import FluxoCaixa from '../pages/PainelExecutivo/fluxoCaixa';
import Colaboradores from '../pages/Colaboradores/colaboradores';
import Dre from '../pages/PainelExecutivo/dre';
import Release2025 from '../pages/PainelExecutivo/release2025';
import Release2026T1 from '../pages/PainelExecutivo/release2026T1';
import Release2026T2 from '../pages/PainelExecutivo/release2026T2';

import VisaoGeral from '../pages/PainelExecutivo/VisaoGeral';
import AdminDashboard from '../pages/Admin/AdminDashboard';
import UsuariosDashboard from '../pages/Admin/UsuariosDashboard';
import AdminHub from '../pages/Admin/AdminHub';
import MapeamentoOrigemDados from '../pages/Admin/mapeamentoOrigemDados';
import OrigemDadosDashboard from '../pages/Admin/OrigemDadosDashboard';
import OmieContratosOS from '../pages/Admin/OmieContratosOS';
import NovasVendas from '../pages/NovasVendas/novasVendas';
import DespesasGerais from '../pages/GestaoOrcamentaria/despesasGerais';
import CustosGerais from '../pages/GestaoOrcamentaria/custosGerais';
import BoasVindasCustos from '../pages/GestaoOrcamentaria/boasVindasCustos';
import BoasVindasDespesas from '../pages/GestaoOrcamentaria/boasVindasDespesas';
import BoasVindasPremissas from '../pages/GestaoOrcamentaria/boasVindasPremissas';
import GeralOrcamento from '../pages/GestaoOrcamentaria/geralOrcamento';
import PremissasFaturamento from '../pages/GestaoOrcamentaria/premissasFaturamento';
import PremissasMaoDeObra from '../pages/GestaoOrcamentaria/premissasMaoDeObra';
import PremissasViagem from '../pages/GestaoOrcamentaria/premissasViagem';
import PremissasEquipamentos from '../pages/GestaoOrcamentaria/premissasEquipamentos';
import FaturamentoBruto from '../pages/GestaoOrcamentaria/faturamentoBruto';
import NovasVendasOrcamento from '../pages/GestaoOrcamentaria/novasVendasOrcamento';
import CustoNovasVendas from '../pages/GestaoOrcamentaria/custoNovasVendas';
import MaoDeObra from '../pages/GestaoOrcamentaria/maoDeObra';
import AlocacaoPessoal from '../pages/GestaoOrcamentaria/alocacaoPessoal';
import VisaoExecutiva from '../pages/GestaoOrcamentaria/visaoExecutiva';
import VisaoExecutivaCustos from '../pages/GestaoOrcamentaria/visaoExecutivaCustos';
import VisaoExecutivaDespesas from '../pages/GestaoOrcamentaria/visaoExecutivaDespesas';
import CustosGeraisProjeto from '../pages/GestaoOrcamentaria/custosGeraisProjeto';
import DespesasMaoDeObra from '../pages/GestaoOrcamentaria/despesasMaoDeObra';
import DespesasFinanceiras from '../pages/GestaoOrcamentaria/despesasFinanceiras';
import Impostos from '../pages/GestaoOrcamentaria/impostos';
import Investimentos from '../pages/GestaoOrcamentaria/investimentos';
import DreGerencial from '../pages/GestaoOrcamentaria/dreGerencial';
import AnaliseDepartamento from '../pages/GestaoOrcamentaria/analiseDepartamento';
import DreEmpresa from '../pages/GestaoOrcamentaria/dreEmpresa';
import { ROLES_DESPESAS_GERAIS, ROLES_CUSTOS_GERAIS, ROLES_GESTAO_ORCAMENTARIA } from '../constants/departamentosOrcamento';
import { ROLES_FATURAMENTO_BRUTO } from '../constants/faturamentoBruto';
import { ROLES_PREMISSAS_FATURAMENTO } from '../constants/premissasFaturamento';
import { ROLES_PREMISSAS_VIAGEM } from '../constants/premissasViagem';
import { ROLES_PREMISSAS_EQUIPAMENTOS } from '../constants/premissasEquipamentos';
import { ROLES_NOVAS_VENDAS_ORCAMENTARIA } from '../constants/novasVendasOrcamento';
import { ROLES_CUSTO_NOVAS_VENDAS_ORCAMENTARIA } from '../constants/custoNovasVendas';
import { ROLES_MAO_DE_OBRA } from '../constants/maoDeObra';
import { ROLES_ALOCACAO_PESSOAL } from '../constants/alocacaoPessoal';
import { ROLES_VISAO_EXECUTIVA } from '../constants/visaoExecutiva';
import { ROLES_VISAO_EXECUTIVA_GERAL } from '../constants/visaoExecutivaGeral';
import { ROLES_CUSTOS_GERAIS_PROJETO } from '../constants/custosGeraisProjeto';
import { ROLES_DESPESAS_FINANCEIRAS } from '../constants/despesasFinanceiras';
import { ROLES_IMPOSTOS } from '../constants/impostos';
import { ROLES_INVESTIMENTOS } from '../constants/investimentos';
import { ROLES_DRE_GERENCIAL } from '../constants/dreGerencial';
import { ROLES_ANALISE_DEPARTAMENTO } from '../constants/analiseDepartamento';
import { ROLES_DRE_EMPRESA } from '../constants/dreEmpresa';
import CentralAjuda from '../pages/CentralAjuda';
import CentralAjudaModulo from '../pages/CentralAjuda/ModuloDocumentacao';
import CentralAjudaAdmin from '../pages/CentralAjuda/AdminFeedback';
import CentralAjudaDashboard from '../pages/CentralAjuda/CentralAjudaDashboard';
export default function AppRoutes() {

  const rolesAtuais = [
    'admin', "RH", "TI", "ADMFIN", "NEGOCIOS", "EXECUTIVA",
    "VIAGENS", "FACILITIES", "COMERCIAL", "QUALIDADE", "JURIDICO",
    "OPERACAO", "MARKETING","GESTOR_ESTRATEGICO","PESSOA&CULTURA","VIAGEMCOMERCIAL" ,"VIAGEMFACILITIES"
  ];

  const rolesCoordenadores = rolesAtuais.map(role => `COORDENADOR_${role}`);
  const todasRolesPermitidas = [...rolesAtuais, ...rolesCoordenadores];
  return (
    <Routes>
      <Route path="/" element={<Login />} />
      <Route path="/cadastro" element={<Register />} />
      <Route path="/esqueci-senha" element={<EsqueciSenha />} />
      <Route path="/redefinir-senha" element={<RedefinirSenha />} />
      <Route
        path="/margem-bruta"
        element={
          <PrivateRoute allowedRoles={['admin', 'financeiro', 'diretor', 'administracao', 'OPERACAO','ASSISTENTEOPERACAO','GESTOR_ESTRATEGICO']}>
            <MargemBruta />
          </PrivateRoute>
        }
      />
      <Route
        path="/margem-bruta-percentual"
        element={
          <PrivateRoute allowedRoles={['admin','HELIO']}>
            <MargemBrutaPercentual/>
          </PrivateRoute>
        }
      />
      <Route
        path="/salarios-por-projeto"
        element={
          <PrivateRoute allowedRoles={['admin', 'rh', 'financeiro', 'diretor']}>
            <SalariosPorProjeto />
          </PrivateRoute>
        }
      />

      <Route
        path="/custos-por-projeto"
        element={
          <PrivateRoute allowedRoles={['admin', 'rh', 'financeiro', 'diretor', 'administracao', 'OPERACAO','ASSISTENTEOPERACAO','GESTOR_ESTRATEGICO']}>
            <CustosPorProjeto />
          </PrivateRoute>
        }
      />

      <Route
        path="/simulacao-folha"
        element={
          <PrivateRoute allowedRoles={['admin', 'rh', 'financeiro', 'diretor', 'OPERACAO','GESTOR_ESTRATEGICO','ASSISTENTEOPERACAO']}>
            <SimuladorFolha />
          </PrivateRoute>
        }
      />

      <Route
        path="/orcamento-dash"
        element={
          <PrivateRoute allowedRoles={todasRolesPermitidas}>
            <OrcamentoDash />
          </PrivateRoute>
        }
      />

      <Route
        path="/inicio"
        element={
          <PrivateRoute>
            <Inicio />
          </PrivateRoute>
        }
      />
      <Route
        path="/painel-executivo"
        element={
          <PrivateRoute allowedRoles={['admin', 'financeiro', 'diretor','GESTOR_ESTRATEGICO','COORDENADOR_RH']}>
            <PainelExecutivo />
          </PrivateRoute>
        }
      />
      <Route
        path="/painel-pagamentos"
        element={
          <PrivateRoute allowedRoles={['admin', 'financeiro', 'diretor']}>
            <Pagamentos />
          </PrivateRoute>
        }
      />
      <Route
        path="/painel-recebimentos"
        element={
          <PrivateRoute allowedRoles={['admin', 'financeiro', 'diretor']}>
            <Recebimentos />
          </PrivateRoute>
        }
      />
      <Route
        path="/painel-formulario"
        element={
          <PrivateRoute allowedRoles={['admin', 'financeiro', 'diretor','GP',"OPERACAO","ASSISTENTEOPERACAO","onlyFormulario"]}>
            <GoogleFormFinanceiro />
          </PrivateRoute>
        }
      />
      <Route
        path="/minhas-solicitacoes"
        element={
          <PrivateRoute allowedRoles={['admin', 'financeiro', 'diretor', 'GP', 'OPERACAO', 'GESTOR_ESTRATEGICO', 'ASSISTENTEOPERACAO','OPERACAO']}>
            <MinhasSolicitacoes />
          </PrivateRoute>
        }
      />
      <Route
        path="/painel-faturamento"
        element={
          <PrivateRoute allowedRoles={['admin', 'financeiro', 'diretor', 'GP', 'OPERACAO', 'GESTOR_ESTRATEGICO', 'ASSISTENTEOPERACAO','OPERACAO']}>
            <FaturamentoGp />
          </PrivateRoute>
        }
      />
      <Route
        path="/painel-inadimplencia"
        element={
          <PrivateRoute allowedRoles={['admin', 'financeiro', 'diretor','GP','GESTOR_ESTRATEGICO','OPERACAO','GESTOR_ESTRATEGICO','ASSISTENTEOPERACAO','OPERACAO']}>
            <Inadimplencia />
          </PrivateRoute>
        }
      />
      <Route
        path="/painel-competencia"
        element={
          <PrivateRoute allowedRoles={['admin', 'financeiro', 'diretor','GP','GESTOR_ESTRATEGICO','OPERACAO','ASSISTENTEOPERACAO','OPERACAO']}>
            <ControleCompetencia/>
          </PrivateRoute>
        }
      />
      <Route
        path="/painel-inadimplencia-dash"
        element={
          <PrivateRoute allowedRoles={['admin', 'financeiro', 'diretor','GESTOR_ESTRATEGICO','COORDENADOR_RH']}>
            <Inadimplencia />
          </PrivateRoute>
        }
      />
      <Route
        path="/painel-competencia-dash"
        element={
          <PrivateRoute allowedRoles={['admin', 'financeiro', 'diretor','GESTOR_ESTRATEGICO','COORDENADOR_RH']}>
            <ControleCompetencia/>
          </PrivateRoute>
        }
      />
      <Route
        path="/painel-fluxo-caixa-dash"
        element={
          <PrivateRoute allowedRoles={['admin', 'financeiro', 'diretor','GESTOR_ESTRATEGICO','COORDENADOR_RH']}>
            <FluxoCaixa/>
          </PrivateRoute>
        }
      />
      <Route
        path="/orcamento-operacao"
        element={
          <PrivateRoute allowedRoles={['admin', 'financeiro', 'diretor', 'OPERACAO', 'ASSISTENTEOPERACAO', 'GESTOR_ESTRATEGICO']}>
            <TabelaLuciano />
          </PrivateRoute>
        }
      />
      <Route
        path="/dre"
        element={
          <PrivateRoute allowedRoles={['admin','GESTOR_ESTRATEGICO','COORDENADOR_RH']}>
            <Dre />
          </PrivateRoute>
        }
      />
      <Route
        path="/painel-release2025-dash"
        element={
          <PrivateRoute allowedRoles={['admin', 'financeiro', 'diretor', 'GESTOR_ESTRATEGICO','COORDENADOR_RH']}>
            <Release2025 />
          </PrivateRoute>
        }
      />
      <Route
        path="/painel-release2026-t1-dash"
        element={
          <PrivateRoute allowedRoles={['admin', 'financeiro', 'diretor', 'GESTOR_ESTRATEGICO','COORDENADOR_RH']}>
            <Release2026T1 />
          </PrivateRoute>
        }
      />
      <Route
        path="/painel-release2026-t2-dash"
        element={
          <PrivateRoute allowedRoles={['admin', 'financeiro', 'diretor', 'GESTOR_ESTRATEGICO','COORDENADOR_RH']}>
            <Release2026T2 />
          </PrivateRoute>
        }
      />
      <Route
        path="/dash/visao-geral"
        element={
          <PrivateRoute allowedRoles={['admin', 'financeiro', 'diretor', 'GESTOR_ESTRATEGICO','COORDENADOR_RH']}>
            <VisaoGeral />
          </PrivateRoute>
        }
      />
      <Route
        path="/admin"
        element={
          <PrivateRoute allowedRoles={['admin']}>
            <AdminHub />
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/dashboard"
        element={
          <PrivateRoute allowedRoles={['admin']}>
            <AdminDashboard />
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/dashboard/graficos"
        element={
          <PrivateRoute allowedRoles={['admin']}>
            <UsuariosDashboard />
          </PrivateRoute>
        }
      />
      <Route
        path="/omie/contratos-os"
        element={
          <PrivateRoute allowedRoles={['admin']}>
            <OmieContratosOS />
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/mapeamento-origem-dados"
        element={
          <PrivateRoute allowedRoles={['admin']}>
            <MapeamentoOrigemDados />
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/mapeamento-origem-dados/dashboard"
        element={
          <PrivateRoute allowedRoles={['admin']}>
            <OrigemDadosDashboard />
          </PrivateRoute>
        }
      />
      <Route
        path="/novas-vendas"
        element={
          <PrivateRoute allowedRoles={['admin', 'financeiro', 'diretor', 'OPERACAO', 'ASSISTENTEOPERACAO', 'COMERCIAL', 'GESTOR_ESTRATEGICO']}>
            <NovasVendas />
          </PrivateRoute>
        }
      />
      <Route
        path="/central-ajuda"
        element={
          <PrivateRoute>
            <CentralAjuda />
          </PrivateRoute>
        }
      />
      <Route
        path="/central-ajuda/admin"
        element={
          <PrivateRoute allowedRoles={['admin']}>
            <CentralAjudaAdmin />
          </PrivateRoute>
        }
      />
      <Route
        path="/central-ajuda/admin/dashboard"
        element={
          <PrivateRoute allowedRoles={['admin']}>
            <CentralAjudaDashboard />
          </PrivateRoute>
        }
      />
      <Route
        path="/central-ajuda/:moduloId"
        element={
          <PrivateRoute>
            <CentralAjudaModulo />
          </PrivateRoute>
        }
      />
      <Route
        path="/gestao-orcamentaria/geral"
        element={
          <PrivateRoute allowedRoles={ROLES_GESTAO_ORCAMENTARIA}>
            <GeralOrcamento />
          </PrivateRoute>
        }
      />
      <Route
        path="/gestao-orcamentaria/despesas-gerais"
        element={
          <PrivateRoute allowedRoles={ROLES_DESPESAS_GERAIS}>
            <DespesasGerais />
          </PrivateRoute>
        }
      />
      <Route
        path="/gestao-orcamentaria/custos-gerais"
        element={
          <PrivateRoute allowedRoles={ROLES_CUSTOS_GERAIS}>
            <CustosGerais />
          </PrivateRoute>
        }
      />
      <Route
        path="/gestao-orcamentaria/boas-vindas-custos"
        element={
          <PrivateRoute allowedRoles={ROLES_ALOCACAO_PESSOAL}>
            <BoasVindasCustos />
          </PrivateRoute>
        }
      />
      <Route
        path="/gestao-orcamentaria/boas-vindas-despesas"
        element={
          <PrivateRoute allowedRoles={ROLES_DESPESAS_GERAIS}>
            <BoasVindasDespesas />
          </PrivateRoute>
        }
      />
      <Route
        path="/gestao-orcamentaria/boas-vindas-premissas"
        element={
          <PrivateRoute allowedRoles={ROLES_PREMISSAS_VIAGEM}>
            <BoasVindasPremissas />
          </PrivateRoute>
        }
      />
      <Route
        path="/gestao-orcamentaria/premissas-faturamento"
        element={
          <PrivateRoute allowedRoles={ROLES_PREMISSAS_FATURAMENTO}>
            <PremissasFaturamento />
          </PrivateRoute>
        }
      />
      <Route
        path="/gestao-orcamentaria/premissas-mao-de-obra"
        element={
          <PrivateRoute allowedRoles={ROLES_MAO_DE_OBRA}>
            <PremissasMaoDeObra />
          </PrivateRoute>
        }
      />
      <Route
        path="/gestao-orcamentaria/premissas-viagem"
        element={
          <PrivateRoute allowedRoles={ROLES_PREMISSAS_VIAGEM}>
            <PremissasViagem />
          </PrivateRoute>
        }
      />
      <Route
        path="/gestao-orcamentaria/premissas-equipamentos"
        element={
          <PrivateRoute allowedRoles={ROLES_PREMISSAS_EQUIPAMENTOS}>
            <PremissasEquipamentos />
          </PrivateRoute>
        }
      />
      <Route
        path="/gestao-orcamentaria/faturamento-bruto"
        element={
          <PrivateRoute allowedRoles={ROLES_FATURAMENTO_BRUTO}>
            <FaturamentoBruto />
          </PrivateRoute>
        }
      />
      <Route
        path="/gestao-orcamentaria/novas-vendas"
        element={
          <PrivateRoute allowedRoles={ROLES_NOVAS_VENDAS_ORCAMENTARIA}>
            <NovasVendasOrcamento />
          </PrivateRoute>
        }
      />
      <Route
        path="/gestao-orcamentaria/custo-novas-vendas"
        element={
          <PrivateRoute allowedRoles={ROLES_CUSTO_NOVAS_VENDAS_ORCAMENTARIA}>
            <CustoNovasVendas />
          </PrivateRoute>
        }
      />
      <Route
        path="/gestao-orcamentaria/custo-mao-de-obra"
        element={
          <PrivateRoute allowedRoles={ROLES_MAO_DE_OBRA}>
            <MaoDeObra />
          </PrivateRoute>
        }
      />
      <Route
        path="/gestao-orcamentaria/despesas-mao-de-obra"
        element={
          <PrivateRoute allowedRoles={ROLES_MAO_DE_OBRA}>
            <DespesasMaoDeObra />
          </PrivateRoute>
        }
      />
      <Route
        path="/gestao-orcamentaria/alocacao-pessoal"
        element={
          <PrivateRoute allowedRoles={ROLES_ALOCACAO_PESSOAL}>
            <AlocacaoPessoal />
          </PrivateRoute>
        }
      />
      <Route
        path="/gestao-orcamentaria/visao-executiva"
        element={
          <PrivateRoute allowedRoles={ROLES_VISAO_EXECUTIVA}>
            <VisaoExecutiva />
          </PrivateRoute>
        }
      />
      <Route
        path="/gestao-orcamentaria/visao-executiva-custos"
        element={
          <PrivateRoute allowedRoles={ROLES_VISAO_EXECUTIVA_GERAL}>
            <VisaoExecutivaCustos />
          </PrivateRoute>
        }
      />
      <Route
        path="/gestao-orcamentaria/visao-executiva-despesas"
        element={
          <PrivateRoute allowedRoles={ROLES_VISAO_EXECUTIVA_GERAL}>
            <VisaoExecutivaDespesas />
          </PrivateRoute>
        }
      />
      <Route
        path="/gestao-orcamentaria/custos-gerais-projeto"
        element={
          <PrivateRoute allowedRoles={ROLES_CUSTOS_GERAIS_PROJETO}>
            <CustosGeraisProjeto />
          </PrivateRoute>
        }
      />
      <Route
        path="/gestao-orcamentaria/despesas-financeiras"
        element={
          <PrivateRoute allowedRoles={ROLES_DESPESAS_FINANCEIRAS}>
            <DespesasFinanceiras />
          </PrivateRoute>
        }
      />
      <Route
        path="/gestao-orcamentaria/impostos"
        element={
          <PrivateRoute allowedRoles={ROLES_IMPOSTOS}>
            <Impostos />
          </PrivateRoute>
        }
      />
      <Route
        path="/gestao-orcamentaria/investimentos"
        element={
          <PrivateRoute allowedRoles={ROLES_INVESTIMENTOS}>
            <Investimentos />
          </PrivateRoute>
        }
      />
      <Route
        path="/gestao-orcamentaria/dre-gerencial"
        element={
          <PrivateRoute allowedRoles={ROLES_DRE_GERENCIAL}>
            <DreGerencial />
          </PrivateRoute>
        }
      />
      <Route
        path="/gestao-orcamentaria/analise-departamento"
        element={
          <PrivateRoute allowedRoles={ROLES_ANALISE_DEPARTAMENTO}>
            <AnaliseDepartamento />
          </PrivateRoute>
        }
      />
      <Route
        path="/gestao-orcamentaria/dre-empresa"
        element={
          <PrivateRoute allowedRoles={ROLES_DRE_EMPRESA}>
            <DreEmpresa />
          </PrivateRoute>
        }
      />
      <Route
        path="/colaboradores"
        element={
          <PrivateRoute allowedRoles={[      
            "admin",
            "RH",
            "TI",
            "ADMFIN",
            "NEGOCIOS",
            "EXECUTIVA",
            "COMERCIAL",
            "QUALIDADE",
            "JURIDICO",
            "OPERACAO",
            "MARKETING",
            "GESTOR_ESTRATEGICO",
            "PESSOA&CULTURA"
      ]}>
            <Colaboradores />
          </PrivateRoute>
        }
      />
    </Routes>
  );
}
